import BucketDealTable from "./components/Bucket-Deal-Table/BucketDealTable";

export default function BucketDeals() {
  return <div>{<BucketDealTable></BucketDealTable>}</div>;
}
